"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationsFromDocumentConverter = void 0;
const lodash_1 = __importDefault(require("lodash"));
const ToolsOperationsFactory_1 = require("../../ToolsOperationsFactory");
const constants_1 = __importDefault(require("../../constants"));
const utils_1 = require("../../utils");
const operationsFactory = new ToolsOperationsFactory_1.ToolsOperationsFactory();
class OperationsFromDocumentConverter {
    convert(document, options = {}) {
        const anonymizedDocument = {};
        // #region  pages
        const documentPagesArray = this._extractPagesArray(document, options);
        if (options.merge) {
            options.merge.pageCount = documentPagesArray.length;
        }
        const [pagesIterationOrder = [], pagesOperation] = (() => {
            if (!documentPagesArray.length)
                return [];
            return [this._getPagesOrder(documentPagesArray, options), operationsFactory.pages(documentPagesArray)];
        })();
        const templateOperationsIndex = {};
        // #endregion
        // #region template
        const templatedOperationsArray = this._convertFromTemplate(document, Object.assign(Object.assign({}, options), { pagesIterationOrder, onEachFn: (operation, innerOptions) => {
                const { flatArrayIndex, pageId, indexOnPage, element } = innerOptions;
                // check fieldId
                const fieldId = lodash_1.default.get(operation, 'properties.template.id', false);
                templateOperationsIndex[fieldId] = flatArrayIndex;
                if (options.isAnonymizeDocument && element) {
                    if (!anonymizedDocument.fields)
                        anonymizedDocument.fields = { metadata: document.fields.metadata, list: [] };
                    utils_1.addToPage(anonymizedDocument.fields, utils_1.anonymizeField(element), {
                        pageId,
                        indexOnPage,
                    });
                }
                return operation;
            } }));
        // #endregion
        // #region content
        const contentFreeToolOperations = this._convertFromContent(document, Object.assign(Object.assign({}, options), { pagesIterationOrder, onEachFn: (operationContent, innerOptions) => {
                const { pageId, indexOnPage, element } = innerOptions;
                const linkId = lodash_1.default.get(operationContent, 'properties.content.linkId', false);
                const templateOperationIndex = linkId ? templateOperationsIndex[linkId] : false;
                if (options.isAnonymizeDocument && element) {
                    if (!anonymizedDocument.content)
                        anonymizedDocument.content = { metadata: document.content.metadata, list: [] };
                    utils_1.addToPage(anonymizedDocument.content, utils_1.anonymizeContent(element), {
                        pageId,
                        indexOnPage,
                    });
                }
                // return to contentFreeToolOperations
                if (templateOperationIndex === false)
                    return operationContent;
                // process as linked content operation
                const content = lodash_1.default.get(operationContent, 'properties.content', false);
                if (content) {
                    lodash_1.default.set(templatedOperationsArray[templateOperationIndex], 'properties.content', content);
                }
                // skip for contentFreeToolOperations
                return false;
            } }));
        // #endregion
        // comments
        const commentOperations = this._convertFromComments(document, Object.assign(Object.assign({}, options), { pagesIterationOrder, onEachFn: (operationComment, innerOptions) => {
                const { pageId, indexOnPage, element } = innerOptions;
                if (options.isAnonymizeDocument && element) {
                    if (!anonymizedDocument.comments)
                        anonymizedDocument.comments = { metadata: document.content.metadata, list: [] };
                    utils_1.addToPage(anonymizedDocument.comments, utils_1.anonymizeComment(element), {
                        pageId,
                        indexOnPage,
                    });
                }
                return operationComment;
            } }));
        // attributes
        const attributesOperations = this._convertFromAttributes(document, options);
        // resolution operation
        const resolutionOperation = this._getResolutionOperation(document);
        const contentLayerArray = [...templatedOperationsArray, ...contentFreeToolOperations];
        return Object.assign(Object.assign(Object.assign({}, (pagesOperation ? { pages: [pagesOperation] } : { pages: [] })), { content: contentLayerArray.length ? contentLayerArray : [], comments: commentOperations.length ? commentOperations : [], attributes: attributesOperations.length ? attributesOperations : [], resolution: resolutionOperation ? [resolutionOperation] : [] }), (options.isAnonymizeDocument ? { anonymizedDocument } : {}));
    }
    _createFlatOperationsFromPagedEntity(entityWithPages, pagesOrder, createOperationFn) {
        if (!pagesOrder || !pagesOrder.length || pagesOrder.length > entityWithPages.length) {
            pagesOrder = entityWithPages.map((_i, ind) => ind);
        }
        return pagesOrder.reduce((acc, pageId) => {
            const page = entityWithPages[pageId];
            if (!page)
                return acc;
            return page.reduce((accInner, element, indexOnPage) => {
                const flatArrayIndex = accInner.length;
                const operation = createOperationFn(element, { pageId, indexOnPage, flatArrayIndex });
                if (!operation)
                    return accInner;
                accInner.push(operation);
                return accInner;
            }, acc);
        }, []);
    }
    makeTemplatePrefixes(template, options) {
        var _a;
        const newId = this.getNewId(template.id, options);
        template = Object.assign(Object.assign({}, template), { name: options.prefix + template.name, id: newId, 
            // TODO: check it out - do we need this? Must me it should do converter
            required: !!template.required });
        if (typeof template.formula === 'string' && template.formula) {
            template.formula = template.formula.replace(/\{/g, `{${options.prefix}`);
        }
        if (template.dependency) {
            if ('name' in template.dependency)
                template.dependency.name = options.prefix + ((_a = template.dependency.name) !== null && _a !== void 0 ? _a : '');
            if ('clauses' in template.dependency)
                template.dependency.clauses = template.dependency.clauses.map((dependency) => (Object.assign(Object.assign({}, dependency), { name: dependency.name !== undefined ? options.prefix + dependency.name : undefined })));
        }
        return template;
    }
    _getPagesOrder(pages, options = {}) {
        const pageShift = parseInt(lodash_1.default.get(options, 'merge.pageShift', 0), 10);
        return pages.reduce((order, p, index) => {
            if (p.visible) {
                order.push(pageShift + index);
            }
            return order;
        }, []);
    }
    _extractPagesArray(doc, options = {}) {
        const pageShift = parseInt(lodash_1.default.get(options, 'merge.pageShift', 0), 10);
        const pages = lodash_1.default.get(doc, 'pages.list', []);
        return pages.map((page) => (Object.assign(Object.assign({}, page), { source: pageShift + page.source })));
    }
    _extractArray(shape, options = {}) {
        if (!shape || !shape.list || !Array.isArray(shape.list))
            return [];
        const pageShift = parseInt(lodash_1.default.get(options, 'merge.pageShift', 0), 10);
        const entityArr = shape.list;
        return entityArr.reduce((acc, page, pageIndex) => {
            const newIndex = pageShift + pageIndex;
            acc[newIndex] = page;
            return acc;
        }, []);
    }
    _extractAttributesHash(doc) {
        return lodash_1.default.get(doc, 'attributes.list', {});
    }
    _convertFromTemplate(document, options) {
        const { pagesIterationOrder, onEachFn } = options;
        const documentTemplate = this._extractArray(document.fields, options);
        if (!documentTemplate.length)
            return [];
        options.prefix = this.getPrefix(options);
        let _orderMax = 0;
        try {
            return this._createFlatOperationsFromPagedEntity(documentTemplate, pagesIterationOrder, (template, { pageId, indexOnPage, flatArrayIndex }) => {
                const { type = 'text', subType = 'none' } = template;
                template = Object.assign(Object.assign({}, template), { 
                    // TODO: check it out - do we need this? Must me it should do converter
                    required: !!template.required });
                template = this.makeTemplatePrefixes(template, options);
                // TODO: check it out - do we need this? Must me it should do converter
                if (typeof template.order === 'undefined' || template.order <= _orderMax)
                    template.order = ++_orderMax;
                else
                    _orderMax = Math.max(_orderMax, template.order);
                // TODO: check it out - do we need this? It should do converter
                // if (template.type === CONST.TYPE.SIGNATURE && template.subType === 'initials') {
                //   template.restrictSubTypes = ['text'];
                // }
                const operationTemplate = operationsFactory.template({
                    type,
                    subType,
                    pageId,
                    template,
                });
                return typeof onEachFn === 'function'
                    ? onEachFn(operationTemplate, {
                        pageId,
                        indexOnPage,
                        flatArrayIndex,
                        element: template,
                    })
                    : operationTemplate;
            });
        }
        catch (err) {
            throw new Error(`Template failed :: ${err.message}`);
        }
    }
    getPrefix(options) {
        const docIndex = lodash_1.default.get(options, 'merge.documentIndex', false);
        if (docIndex === false)
            return '';
        return `${constants_1.default.DOC_PREFIX_BASE}${docIndex}${constants_1.default.DOC_PREFIX_SEP}`;
    }
    getNewId(id, options) {
        const strId = id.toString();
        if (!options.idMapping)
            options.idMapping = {};
        if (options.idMapping[strId])
            return options.idMapping[strId];
        options.idMapping[strId] = options.prefix + strId;
        return options.idMapping[strId];
    }
    _convertFromContent(document, options) {
        const { pagesIterationOrder, onEachFn } = options;
        const documentContent = this._extractArray(document.content, options);
        if (!documentContent.length)
            return [];
        options.prefix = this.getPrefix(options);
        try {
            return this._createFlatOperationsFromPagedEntity(documentContent, pagesIterationOrder, (content, { pageId, indexOnPage, flatArrayIndex }) => {
                const { type = 'text', subType = 'none', linkId } = content;
                const operationContent = operationsFactory.content({
                    type,
                    subType,
                    content: Object.assign(Object.assign({}, content), (linkId
                        ? { linkId: this.getNewId(linkId, options) }
                        : {})),
                    pageId,
                });
                return typeof onEachFn === 'function'
                    ? onEachFn(operationContent, {
                        pageId,
                        indexOnPage,
                        flatArrayIndex,
                        element: content,
                    })
                    : operationContent;
            });
        }
        catch (err) {
            throw new Error(`Content failed :: ${err.message}`);
        }
    }
    _convertFromComments(document, options) {
        const { pagesIterationOrder, onEachFn } = options;
        const comments = this._extractArray(document.comments, options);
        if (!comments.length)
            return [];
        try {
            return this._createFlatOperationsFromPagedEntity(comments, pagesIterationOrder, (comment, { pageId, indexOnPage, flatArrayIndex }) => {
                const operation = operationsFactory.comment(comment, pageId);
                return typeof onEachFn === 'function'
                    ? onEachFn(operation, {
                        pageId,
                        indexOnPage,
                        flatArrayIndex,
                        element: comment,
                    })
                    : operation;
            });
        }
        catch (err) {
            throw new Error(`Content failed :: ${err.message}`);
        }
    }
    _convertFromAttributes(document, options) {
        const attributes = this._extractAttributesHash(document);
        if (lodash_1.default.isEmpty(attributes))
            return [];
        return Object.keys(attributes).map((attributeKey) => {
            const attrContent = attributes[attributeKey].content;
            if (options.merge) {
                attrContent.pagesRange = utils_1.shiftRange(attrContent.pagesRange, options.merge);
            }
            const operation = operationsFactory.attribute(attributeKey, attrContent);
            return operation;
        });
    }
    _getResolutionOperation(document) {
        const dpi = (() => {
            const dpiContent = lodash_1.default.get(document, 'content.metadata.dpi', false);
            if (dpiContent)
                return dpiContent;
            const dpiFields = lodash_1.default.get(document, 'fields.metadata.dpi', false);
            if (dpiFields)
                return dpiFields;
            const dpiAttr = lodash_1.default.get(document, 'attributes.metadata.dpi', false);
            if (dpiAttr)
                return dpiAttr;
            const dpiComments = lodash_1.default.get(document, 'comments.metadata.dpi', false);
            if (dpiComments)
                return dpiComments;
            return 72;
        })();
        return operationsFactory.create(constants_1.default.GROUP.DOCUMENT, constants_1.default.TYPE.RESOLUTION, '', {
            pdfDPI: 72,
            contentDPI: dpi,
        });
    }
}
exports.OperationsFromDocumentConverter = OperationsFromDocumentConverter;
//# sourceMappingURL=index.js.map